import connectAsync from '../../utils/connectAsync';
import { isDiscountEnabled } from '../utils/subscriptionProductDetails';
import parse from '../../utils/queryString/parse';
import { fetchMe } from '../../actions/me';
import {
  selectExperiment,
  selectIsSubscriptionEnabled,
} from '../../selectors/config';
import { PAYMENT_FLOW } from '../../constants/subscription/flow';
import fetchProducts from '../../utils/connectors/fetchProducts';
import { AUTH_PAYMENT_FORM_PREVIEW_ENABLED } from '../../constants/experiments/auth';
import isCouponFlow from '../../utils/subscription/isCouponFlow';
import AuthPageRoute from './AuthPageRoute';

// exported for testing purposes
export function fetchProductsIfNeeded({ store, location }) {
  const state = store.getState();
  const query = parse(location?.search || '');
  const isPaymentFlow = !!query[PAYMENT_FLOW];
  const isPaymentPreviewEnabled = selectExperiment(
    state,
    AUTH_PAYMENT_FORM_PREVIEW_ENABLED,
  );
  const isDiscounted = isDiscountEnabled(location) || isCouponFlow(location);

  if (
    selectIsSubscriptionEnabled(state) &&
    isPaymentFlow &&
    (query.sku || isPaymentPreviewEnabled || isDiscounted)
  ) {
    return fetchProducts(location);
  }
  return null;
}

export default connectAsync([fetchMe, fetchProductsIfNeeded])(AuthPageRoute);
